module.exports = __webpack_public_path__ + "static/media/russia.0dcd4306.svg";